import AddNewLoan from "./AddNewLoan";
export default AddNewLoan;
